<cp-popover class="exchange-1035-breakdown-popover">
  <a label href="javascript:void(0)">
    {{ actionItem.displayText }}
  </a>
  <div content>
    <div class="exchange-1035-breakdown-popover__row">
      <span class="exchange-1035-breakdown-popover__data-label">Applies toward initial premium</span>
      <span class="exchange-1035-breakdown-popover__data-value">{{ amountTowardsPremium | casCurrency }}</span>
    </div>
    <div class="exchange-1035-breakdown-popover__row">
      <span class="exchange-1035-breakdown-popover__data-label">Applies toward Additional Life Insurance Rider</span>
      <span class="exchange-1035-breakdown-popover__data-value">{{ amountTowardsAlir | casCurrency }}</span>
    </div>
    <div class="exchange-1035-breakdown-popover__divider"></div>
    <div class="exchange-1035-breakdown-popover__row exchange-1035-breakdown-popover__row--final">
      <span class="exchange-1035-breakdown-popover__data-label">
        <ng-container *ngIf="fundsReceived">Amount transferred</ng-container>
        <ng-container *ngIf="!fundsReceived">Amount to be transferred</ng-container>
      </span>
      <span class="exchange-1035-breakdown-popover__data-value">{{ transferAmount | casCurrency }}</span>
    </div>
  </div>
</cp-popover>
